<script>
import { filtersComputed, filtersMethods, deviceGroupComputed } from '@state/helpers'

export default {
  computed: {
    ...filtersComputed,
    ...deviceGroupComputed,

    filteredGroups: function() {
      return this.cachedGroups.filter((group) => {
        if (this.deviceFilters.searchGroup && this.deviceFilters.name != null) {
          return group.name.toLowerCase().includes(this.deviceFilters.name.toLowerCase())
        } else {
          return this.cachedGroups
        }
      })
    },
  },

  methods: {
    ...filtersMethods,

    toggleShowRunningChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.showRunning = event.target.checked

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    toggleShowIdleChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.showIdle = event.target.checked

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    toggleSearchGroupChanged: function(event) {
      let newDeviceFilters = { ...this.deviceFilters }
      newDeviceFilters.searchGroup = event.target.checked
      newDeviceFilters.name = null

      this.setDeviceFilters({ device: newDeviceFilters })
    },

    deviceNameChanged: function(name) {
      let newDeviceFilters = { ...this.deviceFilters }

      newDeviceFilters.name = name.toUpperCase()
      this.setDeviceFilters({
        device: newDeviceFilters,
      })
    },

    selectedGroupChanged: function(groupName) {
      if (groupName === this.deviceFilters.name) {
        let newDeviceFilters = { ...this.deviceFilters }
        newDeviceFilters.searchGroup = false
        newDeviceFilters.name = null

        this.setDeviceFilters({ device: newDeviceFilters })
      } else {
        let newDeviceFilters = { ...this.deviceFilters }
        newDeviceFilters.searchGroup = true
        newDeviceFilters.name = groupName

        this.setDeviceFilters({ device: newDeviceFilters })
      }
    },
  },
}
</script>

<template>
  <div class="">
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info p-0 pb-0 mb-0 clearfix"
    >
      <b-form-group class="filter">
        <label for="name" class="w-100 font-weight-bold text-uppercase text-muted mt-2"
          >Name
        </label>
        <b-form-input
          id="name"
          class=" mb-2"
          placeholder="Name..."
          type="text"
          :value="deviceFilters.name"
          @input="deviceNameChanged"
        ></b-form-input>

        <label
          class="align-middle float-right mr-1  font-weight-bold text-uppercase text-muted  ml-1"
          >Group</label
        >
        <label
          class="switch-sm switch switch-label switch-pill  align-middle  float-right"
        >
          <input
            type="checkbox"
            true-value="true"
            false-value="false"
            class="switch-input form-check-input"
            :checked="deviceFilters.searchGroup"
            @change="toggleSearchGroupChanged"
          />
          <span data-checked="" data-unchecked="" class="switch-slider" />
        </label>
        <label
          class="align-middle float-right font-weight-bold text-uppercase text-muted  mr-1"
          >Device</label
        >
      </b-form-group>
    </b-card-body>
    <b-card-body
      class="animated fadeIn card info-card card-body device-card-body-info p-0 pt-1 pb-0 mb-0 clearfix"
    >
      <div class="filter pb-1">
        <label class="align-middle text-success font-weight-bold text-uppercase"
          >Show Running</label
        >
        <label
          class="switch switch-label switch-pill switch-success  align-middle  float-right"
        >
          <input
            type="checkbox"
            true-value="true"
            false-value="false"
            class="switch-input form-check-input"
            :checked="deviceFilters.showRunning"
            @change="toggleShowRunningChanged"
          />
          <span data-checked="On" data-unchecked="Off" class="switch-slider" />
        </label>
      </div>

      <div class="filter pb-2">
        <label class="align-middle text-primary font-weight-bold text-uppercase"
          >Show Idle</label
        >
        <label
          class="switch switch-label switch-pill switch-primary  align-middle  float-right"
        >
          <input
            type="checkbox"
            true-value="true"
            false-value="false"
            class="switch-input form-check-input"
            :checked="deviceFilters.showIdle"
            @change="toggleShowIdleChanged"
          />
          <span data-checked="On" data-unchecked="Off" class="switch-slider" />
        </label>
      </div>
    </b-card-body>
    <b-tabs>
      <b-tab title="GROUP" active>
        <button
          v-for="group in filteredGroups"
          :key="group.id"
          type="button"
          class="insights-list list-group-item list-group-item-action text-uppercase"
          @click="selectedGroupChanged(group.name)"
        >
          {{ group.name }}
        </button>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style>
.filter {
  padding: 1rem;
  border-bottom: 1px solid #23282c;
  margin-bottom: 0 !important;
}

.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}

.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
.aside-menu .nav-tabs .nav-link {
  font-size: 1.09375rem !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}
.insights-list:first-child {
  border-top: none;
}
</style>
